import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { extraReducers } from './extra-reducers';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const contentSlice = createAppSlice({
  name: 'content',
  initialState,
  reducers,
  extraReducers,
});

export const {
  loadProducts,
  deleteProduct,
  promoteProduct,
  updateProduct,
  loadDocuments,
  loadPendingDownloads,
  loadRecordings,
  loadUploadedVideos,
  setViewType,
  setSearch,
  setSortBy,
  setPageNumber,
  exitEditing,
  updateContentMarkedForDeletion,
  updateContentMarkedForDeletionAll,
  setSelectedFileType,
  setContentTypeToAdd,
  setProjectsFilter,
  setProductAttributesFilter,
  setCurrentContent,
  createUploadJob,
  updateUploadJob,
  finishUploadJob,
  clearUploadedVideos,
  clearRecordings,
  clearUploadJobs,
  loadTemplates,
  loadFonts,
  loadThemePacks,
  deleteDocuments,
  deleteRecording,
  deleteUploadedVideo,
  deleteThemePack,
  editUploadedVideo,
  addUploadedVideo,
  videoConversionUpdate,
} = contentSlice.actions;

export default contentSlice.reducer;
